/**
 * This mixin is used for common table cell component logic.
 */
export default {
  props: {
    props: {
      type: Object,
      required: true
    }
  },
  computed: {
    showFilter () {
      if (!this.props.col.filterEnabled) return false
      if (this.props.col.filterDisabled) return false

      return true
    },
    appliedFilter () {
      if (this.props.col.filter !== this.props.value) return false

      return true
    }
  },
  emits: ['filter'],
  methods: {
    applyFilter () {
      this.$emit('filter', { name: this.props.col.name, value: this.props.value })
    },
    clearFilter () {
      this.$emit('filter', { name: this.props.col.name, value: null })
    }
  }
}
